/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

  $.fn.unveil = function(threshold, callback) {

    var $w = $(window),
        th = threshold || 0,
        retina = window.devicePixelRatio > 1,
        attrib = retina? "data-src-retina" : "data-src",
        images = this,
        loaded;

    this.one("unveil", function() {
      var source = this.getAttribute(attrib);
      source = source || this.getAttribute("data-src");
      if (source) {
        if($(this).is('img')) {
          var srcset = this.getAttribute("data-srcset");
          if (srcset) {
            this.setAttribute("srcset", srcset);
          }

          this.setAttribute("src", source);
        } else {
        	$(this).css("background-image", "url('" + source + "')");
        }
        if (typeof callback === "function") callback.call(this);
      }
    });

    // ignore set threshold and prevent loading images out of viewport on initialisation
    function unveil(isIgnoreThreshold) {
      var trThreshold;
      if (isIgnoreThreshold) {
        trThreshold = 0;
      } else {
        trThreshold = th;
      }

      var inview = images.filter(function() {
        var $e = $(this);
        //if ($e.is(":hidden")) return;
        if ($e.css('display') == 'none') return;
        if ($e.css('visibility') == 'hidden') return;
        if ($e.offset().width == 0 && $e.offset().height == 0) return;

        var wt = $w.scrollTop(),
            wb = wt + $w.height(),
            et = $e.offset().top,
            eb = et + $e.height();

        return eb >= wt - trThreshold && et <= wb + trThreshold && !$(this).hasClass('lazyback');
      });

      loaded = inview.trigger("unveil");
      images = images.not(loaded);
    }

    if (window.common && typeof(window.common.byWindowAction) === "function") {
      window.common.byWindowAction(['scroll', 'resize', 'lookup'], unveil);
    } else {
      $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);
    }

    unveil(true);

    return this;

  };

})(window.jQuery || window.Zepto);
